import styled, { css } from "styled-components";
import { getPropertyByMedia, getThemeTokenParser } from "../helpers";
import { DEFAULT_COLOR, DEFAULT_VARIANT, getVariantByResponsiveProps, tagReplacerByVariant } from "./helpers";
export const Typography = styled.p.attrs(({ variant, as }) => ({
    as: as || tagReplacerByVariant(variant),
})) `
	display: inline;
	${({ variant = DEFAULT_VARIANT }) => getVariantByResponsiveProps(variant)}
	${({ color = DEFAULT_COLOR }) => getPropertyByMedia("color", getThemeTokenParser(color, "colors"))}
	${({ align }) => align && getPropertyByMedia("text-align", align)};
	${({ textTransform }) => getPropertyByMedia("text-transform", textTransform)}
	${({ whiteSpace }) => getPropertyByMedia("white-space", whiteSpace)}
	${({ wordBreak }) => wordBreak && getPropertyByMedia("word-break", wordBreak)}
	${({ display }) => display && getPropertyByMedia("display", display)}
	${({ cursor }) => cursor && getPropertyByMedia("cursor", cursor)}

	${({ textEllipsis }) => textEllipsis &&
    css `
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			${getPropertyByMedia("-webkit-line-clamp", textEllipsis)}
			-webkit-box-orient: vertical;
		`}
`;
//# sourceMappingURL=index.js.map